import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import {useEffect} from 'react'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import PublicIcon from '@mui/icons-material/Public';
import CheckIcon from '@mui/icons-material/Check';
import { changeLanguageSafe } from '../../../../i18n/index'; // مسیر واقعی خودت
import { setLanguageLock } from '../../../../i18n/index';
const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 8,
    marginTop: theme.spacing(1),
    minWidth: 160,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': { padding: '4px 0' },
    '& .MuiMenuItem-root': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '0.9rem',
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.primary.main,
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles('dark', { color: theme.palette.grey[300] }),
  },
}));

const LANGUAGES = [
  { code: 'fa', label: 'فارسی' },
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربیه' },
];

export function LoginLangSwitcher() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
 


 React.useEffect(() => {
    localStorage.removeItem("claims");
    setLanguageLock(false); // ← این خط جدیده و کلیدیه: خود isLocked رو هم ریست می‌کنه، نه فقط localStorage
  }, []);
  

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // console.log(event.currentTarget)
    setAnchorEl(event.currentTarget)
  };
  const handleClose = () => setAnchorEl(null);

  const handleSelectLang = (code: string) => {
    changeLanguageSafe(code);
    handleClose();
  };

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  return (
    <div>
      {isMobile ? (
        // موبایل: فقط آیکون، بدون متن، برای صرفه‌جویی در فضا
        <IconButton
          id="lang-switcher-button"
          aria-controls={open ? 'lang-switcher-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open}
          onClick={handleClick}
          size="small"
          sx={{ border: '1px solid', borderColor: 'divider', color: 'text.secondary' }}
        >
          <PublicIcon fontSize="small" />
        </IconButton>
      ) : (
        // دسکتاپ: دکمه با متن زبان جاری
        <Button
          id="lang-switcher-button"
          aria-controls={open ? 'lang-switcher-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open}
          variant="outlined"
          disableElevation
          size="small"
          onClick={handleClick}
          startIcon={<PublicIcon fontSize="small" />}
          sx={{ borderRadius: 2, textTransform: 'none', fontSize: '0.85rem', px: 1.5 }}
        >
          {currentLang.label}
        </Button>
      )}

      <StyledMenu
        id="lang-switcher-menu"
        slotProps={{ list: { 'aria-labelledby': 'lang-switcher-button' } }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {LANGUAGES.map((lang, index) => (
          <React.Fragment key={lang.code}>
            {index > 0 && <Divider sx={{ my: 0.2 }} />}
            <MenuItem
              onClick={() => handleSelectLang(lang.code)}
              disableRipple
              selected={i18n.language === lang.code}
            >
              {lang.label}
              {i18n.language === lang.code && <CheckIcon />}
            </MenuItem>
          </React.Fragment>
        ))}
      </StyledMenu>
    </div>
  );
}